import React from "react";

/** Every inner sheet opens the same way: the title, then one lede line. */
export default function PageHead({ title, lede }) {
  return (
    <header className="page-head">
      <h1>{title}</h1>
      {lede ? <p className="page-lede">{lede}</p> : null}
    </header>
  );
}
